import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateImgAnatomics = atom({
  key: 'beacon.img.anatomics',
  default: [] as BeaconFilterItem[],
});

export default stateImgAnatomics;
